import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';

import {
  DOMAIN_PROD_URL,
  NuTRAVEL_ADMIN_ACTION_DEV_URL,
  NuTRAVEL_ADMIN_ACTION_PROD_URL,
  PERM_TYPE,
  SKYBONUS_DEV_URL,
  SKYBONUS_PROD_URL
} from '../constants/profile-selector-constants';
import { ProfileTypes } from '../models/nuTravel.interface';
import { AccountState } from '../models/profile-selector.interface';
import { ProfileSelectorFacadeBaseService } from './profile-selector-facade-base.service';

@Injectable({
  providedIn: 'root'
})
export class ProfileSelectorFacadeHelperService extends ProfileSelectorFacadeBaseService {
  redirectToSKyBonusPath(): string {
    const environment = window.location.origin;

    if (environment === DOMAIN_PROD_URL) {
      return (
        this.profileSelectorAdapterService.url.permType_S ?? SKYBONUS_PROD_URL
      );
    } else {
      return (
        this.profileSelectorAdapterService.url.permType_S_Dev ??
        SKYBONUS_DEV_URL
      );
    }
  }

  postAccountTypeSelection(
    accountType: string,
    permType: string,
    companyName: string,
    business: string,
    state: AccountState,
    corporateId: string
  ): Observable<string> {
    return this.getAccountTypeObservable(accountType, corporateId).pipe(
      takeUntil(this.unsubscribe$),
      tap({
        next: (res) =>
          this.handleSuccessResponse(
            res,
            permType,
            business,
            state,
            companyName
          ),
        error: (error) => this.handleErrorResponse(error, permType, companyName)
      })
    );
  }

  handleSuccessResponse(
    res: string,
    permType: string,
    business: string,
    state: AccountState,
    companyName: string
  ): void {
    this.storeCompanyId$.next(true);

    if (res && permType === PERM_TYPE.A) {
      this.handleAdminResponse(business, state, permType, companyName);
    }
  }

  handleErrorResponse(
    error: unknown,
    permType: string,
    companyName: string
  ): void {
    console.error(error);
    this.sendFormPostRequest(permType, companyName);
  }

  handleAdminResponse(
    business: string,
    state: AccountState,
    permType: string,
    companyName: string
  ): void {
    if (this.profileSelectorAdapterService.nuTravelEAMFlag === 'true') {
      this.sendFormPostRequest(permType, companyName);
    } else {
      this.profileSelectorAdapterService.adminLink(
        business,
        state.businessAccountIndex
      );
    }
  }

  sendFormPostRequest(permType: string, companyName: string): void {
    this.skyBonusNuTravelAdapterService.setCompanySelected(companyName);
    const payload = this.skyBonusNuTravelAdapterService.getNuTravelObject();
    if (permType === PERM_TYPE.A) {
      this.createDynamicForm(
        'profileSelector',
        payload,
        this.setActionFormPostURL()
      );
    }
    if (permType === PERM_TYPE.S) {
      this.createDynamicForm('profileSelector', payload, '');
    }
  }

  createDynamicForm(name: string, value: ProfileTypes[], action: string): void {
    const stringfyPayload = JSON.stringify(value);
    const form = document.createElement('form');
    form.action = action;
    form.method = 'post';
    const input = document.createElement('input');
    input.name = name;
    input.value = stringfyPayload;
    input.type = 'hidden';
    form.appendChild(input);
    document.body.appendChild(form);
    form.submit();
  }

  setActionFormPostURL(): string {
    const environment = window.location.origin;
    if (environment === DOMAIN_PROD_URL) {
      return (
        this.profileSelectorAdapterService.url.nuTravelLoginActionUrl_Prod ??
        NuTRAVEL_ADMIN_ACTION_PROD_URL
      );
    } else {
      return (
        this.profileSelectorAdapterService.url.nuTravelLoginActionUrl_Dev ??
        NuTRAVEL_ADMIN_ACTION_DEV_URL
      );
    }
  }
}
